import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: ${({ theme, $narrow }) =>
    $narrow ? theme.layout.maxWidthNarrow : theme.layout.maxWidth};
  margin-left: auto;
  margin-right: auto;
  padding-left: ${({ theme }) => theme.spacing(3)};
  padding-right: ${({ theme }) => theme.spacing(3)};
`;

export const Stack = styled.div`
  display: flex;
  flex-direction: ${({ $direction = "column" }) => $direction};
  align-items: ${({ $align = "stretch" }) => $align};
  justify-content: ${({ $justify = "flex-start" }) => $justify};
  gap: ${({ theme, $gap = 3 }) => theme.spacing($gap)};
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "auto")};
`;

export const Grid = styled.div`
  display: grid;
  gap: ${({ theme, $gap = 3 }) => theme.spacing($gap)};
  grid-template-columns: ${({ $columns = "1fr" }) => $columns};
`;
